import React, { useState, useEffect } from 'react';
import { Box, Typography, TextField } from '@mui/material';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { getClients } from '../../services/api';
import SaidaPorCliente from './saidaporcliente'; // Importa o formulário de saída para o cliente

const SaidasLayout = () => {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedClient, setSelectedClient] = useState(null);

  useEffect(() => {
    getClients()
      .then(response => {
        setClients(response.data);
        setLoading(false);
      })
      .catch(error => {
        console.error('Erro ao obter os clientes:', error);
        setLoading(false);
      });
  }, []);

  // Se um cliente for selecionado, renderiza o formulário específico
  if (selectedClient) {
    return (
      <SaidaPorCliente
        client={selectedClient}
        onBack={() => setSelectedClient(null)}
      />
    );
  }

  // Filtra os clientes procurando nas 4 colunas
  const filteredClients = clients.filter(client => {
    const search = searchTerm.toLowerCase();
    return (
      (client.nome2 && client.nome2.toLowerCase().includes(search)) ||
      (client.name && client.name.toLowerCase().includes(search)) ||
      (client.phone && client.phone.toLowerCase().includes(search)) ||
      (client.email && client.email.toLowerCase().includes(search))
    );
  });

  const handleSelectionChange = (e) => {
    setSelectedClient(e.value);
    console.log('Cliente selecionado:', e.value);
  };

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h6" gutterBottom>
        Lista de Clientes
      </Typography>
      <TextField
        fullWidth
        variant="outlined"
        placeholder="Procurar por cliente"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        sx={{ mb: 2 }}
      />
      <DataTable
        value={filteredClients}
        loading={loading}
        paginator
        rows={10}
        dataKey="id"  
        selectionMode="single"
        selection={selectedClient}
        onSelectionChange={handleSelectionChange}
        rowClassName={(data) =>
          selectedClient && selectedClient.id === data.id ? 'selected-row' : ''
        }
      >
        <Column field="nome2" header="Abreviatura" sortable />
        <Column field="name" header="Nome" sortable />
        <Column field="phone" header="Telefone" sortable />
        <Column field="email" header="Email" sortable />
      </DataTable>
      {/* Estilos para hover e seleção de linha */}
      <style>{`
        .p-datatable-tbody > tr:not(.selected-row):hover {
          background-color: #f5f5f5;
        }
        .selected-row {
          background-color: #c8e6c9 !important;
        }
      `}</style>
    </Box>
  );
};

export default SaidasLayout;
